import React from 'react';
import FormGroup from '@material-ui/core/FormGroup';
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import '../CSS/appointment.css'
import purple from '@material-ui/core/colors/purple';

const styles = theme => ({
  colorSwitchBase: {
    color: "#eaedeb",
    "&$colorChecked": {
      color: "#eaedeb",
      "& + $colorBar": {
        backgroundColor: "#eaedeb"
      }
    }
  },
  colorBar: {},
  colorChecked: {},

});
class BooleanSwitch extends React.Component {
  state = {
    checkedB: false,
  };

  handleChange = name => event => {
    this.setState({ [name]: event.target.checked });
    this.props.checkUseBalance(event.target.checked)
  };

  render() {
     const { classes } = this.props;
    return (
        <FormControlLabel
          className="label"
          control={
            <Switch
              checked={this.state.checkedB}
              onChange={this.handleChange('checkedB')}
              value="checkedB"
              classes={{
                    switchBase: classes.colorSwitchBase,
                    checked: classes.colorChecked,
                    bar: classes.colorBar
              }}
            />
          }
          classes={{
                switchBase: classes.colorSwitchBase,
                checked: classes.colorChecked,
                bar: classes.colorBar
          }}
        />
    );
  }
}
BooleanSwitch.propTypes = {
  classes: PropTypes.object.isRequired
};
export default withStyles(styles)(BooleanSwitch);



// WEBPACK FOOTER //
// ./src/Components/BooleanSwitch.js